import React, { useState,useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { handle401 } from "../../../utils/handleAuthError";

const BASE_URL = "https://dev.sutmmg.codydeasoftech.in/api";

const FabricReceive = () => {
const [fabricList, setFabricList] = useState([]);
  const [showModal, setShowModal] = useState(false);
    const [filters, setFilters] = useState({fabric_id: "",});
    const [showProcureModal, setShowProcureModal] = useState(false);
const [selectedUnit, setSelectedUnit] = useState("");

const [saving, setSaving] = useState(false);
const [isEdit, setIsEdit] = useState(false);
const [editId, setEditId] = useState(null);

    const [procurementList, setProcurementList] = useState([]);
    const [loading, setLoading] = useState(false);
const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [totalPages, setTotalPages] = useState(1);

const today = new Date().toISOString().split("T")[0]; // "YY
const [loadingReqQty, setLoadingReqQty] = useState(false);



const [fabricForm, setFabricForm] = useState({
  date: today,
  fabric_id: "",
  quantity: "",
  requisition_qty: "",
  vendor: "DRDC",
  challan_number: "",
  challan_date: today,
  id: "",
});




const fetchFabricRequisitionQty = async (fabricId) => {
  if (!fabricId) return;

  try {
    setLoadingReqQty(true);

    const res = await axios.post(
      `${BASE_URL}/fabricWiseRequisition`,
      { fabric_id: fabricId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const reqQty = res.data?.data?.[0]?.total_requisition || 0;

    setFabricForm((prev) => ({
      ...prev,
      requisition_qty: reqQty,
    }));

  } catch (error) {
    console.error(error);
    Swal.fire("Alert", "Failed to fetch requisition quantity", "error");
  } finally {
    setLoadingReqQty(false);
  }
};







useEffect(() => {
  fetchFabricList();
}, []);

useEffect(() => { fetchFabricProcurement(1); }, [perPage]);



const fetchFabricProcurement = async (page = 1, fabric_id = "", pageSize = perPage) => {
  try {
    setLoading(true);
const token = localStorage.getItem("token");

    const res = await axios.post(
      `${BASE_URL}/fabricProcurementList`,
      { fabric_id, page, per_page: pageSize },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setProcurementList(res.data?.data || []);
    setPage(res.data.page || 1);
    setTotalRecords(res.data.total_records || 0);
    setTotalPages(
      Math.ceil((res.data.total_records || 0) / (res.data.per_page || pageSize))
    );
  } catch (error) {
    console.error("Fetch failed", error);
  } finally {
    setLoading(false);
  }
};


const fetchFabricList = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/fabricList`,{}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (res.data?.status) {
      setFabricList(res.data.data.fabricList || []);
    } else {
      setFabricList([]);
    }
  } catch (err) {
    console.log("Fabric API Error:", err);

     if (handle401(err)) return;
  }
};



// const handleSaveFabricProcurement = async () => {
//   if (
//     !fabricForm.fabric_id ||
//     !fabricForm.quantity ||
//     !fabricForm.vendor ||
//     !fabricForm.challan_number ||
//     !fabricForm.challan_date
//   ) {
//     Swal.fire("Warning", "Please fill all required fields", "warning");
//     return;
//   }

//   try {
// const token = localStorage.getItem("token");

//     const payload = {
//       date: fabricForm.date,
//       fabric_id: fabricForm.fabric_id,
//       quantity: fabricForm.quantity,
//       vendor: fabricForm.vendor,
//       challan_number: fabricForm.challan_number,
//       challan_date: fabricForm.challan_date,
//       id: editId ? editId : "",
//     };

//     const res = await axios.post(
//       `${BASE_URL}/fabricProcurementAddEdit`,
//       payload,
//       { headers: { Authorization: `Bearer ${token}` } }
//     );

//     if (res.data?.status) {
//       Swal.fire("Success", res.data.message, "success");
//       setShowProcureModal(false);
//       setEditId(null);

//       setFabricForm({
//         date: today,
//         fabric_id: "",
//         quantity: "",
//         requisition_qty: "",
//         vendor: "DRDC",
//         challan_number: "",
//         challan_date: today,
//         id: "",
//       });

//       fetchFabricProcurement(1);
//     }
//   } catch (error) {
//     Swal.fire(
//       "Alert",
//       error.response?.data?.message || "Operation failed",
//       "error"
//     );
//   }
// };


const handleSaveFabricProcurement = async () => {
  if (
    !fabricForm.fabric_id ||
    !fabricForm.quantity ||
    !fabricForm.vendor ||
    !fabricForm.challan_number ||
    !fabricForm.challan_date
  ) {
    Swal.fire("Warning", "Please fill all required fields", "warning");
    return;
  }

  try {
    setSaving(true); // ✅ START LOADER

const token = localStorage.getItem("token");

    const payload = {
      date: fabricForm.date,
      fabric_id: fabricForm.fabric_id,
      quantity: fabricForm.quantity,
      vendor: fabricForm.vendor,
      challan_number: fabricForm.challan_number,
      challan_date: fabricForm.challan_date,
      id: editId ? editId : "",
    };

    const res = await axios.post(
      `${BASE_URL}/fabricProcurementAddEdit`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data?.status) {
      Swal.fire("Success", res.data.message, "success");

      setShowProcureModal(false);
      setEditId(null);

      setFabricForm({
        date: today,
        fabric_id: "",
        quantity: "",
        requisition_qty: "",
        vendor: "DRDC",
        challan_number: "",
        challan_date: today,
        id: "",
      });

      fetchFabricProcurement(1);
    }
  } catch (error) {
    Swal.fire(
      "Alert",
      error.response?.data?.message || "Operation failed",
      "error"
    );
  } finally {
    setSaving(false); // ✅ STOP LOADER ALWAYS
  }
};

const handleAddClick = () => {
  console.log("Opening Add Fabric Receive modal");

  setIsEdit(false);
  setEditId(null);

  setFabricForm({
    date: today,
    fabric_id: "",
    quantity: "",
    requisition_qty: "",
    vendor: "DRDC",
    challan_number: "",
    challan_date: today,
    id: "",
  });

  setShowProcureModal(true);
};

const handleEditClick = (row) => {
  setIsEdit(true);
  setEditId(row.id);

  setFabricForm({
    date: row.custom_date || today,
    fabric_id: row.fabric_master_id || "",
    quantity: row.quantity_in || "",
    requisition_qty: row.current_quantity || "",
    vendor: row.vendor || "DRDC",
    challan_number: row.challan_number || "",
    challan_date: row.challan_date || today,
    id: row.id,
  });

  if (row.fabric_id) {
    fetchFabricRequisitionQty(row.fabric_id);
  }

  setShowProcureModal(true);
};




const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);
  if (isNaN(d)) return "-";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`; // DD/MM/YYYY
};




const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;

    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };







  return (
    <div className="container mt-4" style={{ maxWidth: 1550 }}>
      {/* ================= FILTER CARD ================= */}
      <Card className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}>
        <div className="px-4 py-3 text-white" style={{ background: "#1565C1" }}>
          <h5 className="mb-0 fw-bold">
            <i className="fa-solid fa-filter"></i> Fabric Received list
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
          <Row className="align-items-center">
            <Col md={3}>
  <Form.Group className="mb-3">
    <Form.Label className="fw-semibold text-black">Fabric</Form.Label>
    <Form.Select
      value={filters.fabric_id}
      onChange={(e) =>
        setFilters({ ...filters, fabric_id: e.target.value })
      }
      style={{
        borderRadius: "10px",
        border: "2px solid #1565C1",
      }}
    >
      <option value="">Select Fabric</option>

      {fabricList.map((item) => (
        <option key={item.id} value={item.id}>
          {item.name}
        </option>
      ))}
    </Form.Select>
  </Form.Group>
</Col>
<Col md={3}>
                           <Form.Group className="mb-3">
                                           <Form.Label className="fw-semibold text-dark">Record Showing</Form.Label>

                               <Form.Select
                                style={{
                                               borderRadius: "10px",
                                               border: "2px solid #1565C1",
                                             }}
                                 value={perPage}
                                 onChange={(e) => {
                                   const value = Number(e.target.value);
                                   setPerPage(value);
                                   setPage(1);

                                 }}

                               >
                                 <option value={10}>10 Per Page</option>
                                       <option value={25}>25 Per Page</option>
                                       <option value={50}>50 Per Page</option>
                                       <option value={100}>100 Per Page</option>
                               </Form.Select>
                               </Form.Group>
                           </Col>

            <Col md={2} className="mt-3">
                         <Button
  className="w-100 fw-semibold text-white"
  style={{ background: "#1565C1", borderRadius: "10px" }}
  onClick={() => fetchFabricProcurement(1, filters.fabric_id, perPage)}
>
  <i className="fa-solid fa-magnifying-glass me-2"></i> Search
</Button>

                        </Col>

                        {/* Reset Button */}
                        <Col md={2} className="mt-3">
  <Button
    className="w-100 fw-semibold text-white"
    style={{ background: "#E53935", borderRadius: "10px" }}
    onClick={() => {
      const resetFilters = { fabric_id: "" };

      setFilters(resetFilters);
      setPage(1);
      setPerPage(10);
      fetchFabricProcurement(1, resetFilters.fabric_id);
    }}
  >
    <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
  </Button>
</Col>

          </Row>
        </Card.Body>
      </Card>

            <Button
                          className="mb-3 px-4 text-white fw-semibold"
                          onClick={() => {
  handleAddClick();
}}

                          style={{
                            background: "linear-gradient(135deg, #2E7D32, #66BB6A)",
                            border: "none",
                            borderRadius: "10px",
                            padding: "10px 22px",
                            boxShadow: "0 6px 15px rgba(46,125,50,0.4)",
                            transition: "0.3s",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #1B5E20, #2E7D32)";
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 10px 22px rgba(46,125,50,0.55)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background =
                              "linear-gradient(135deg, #2E7D32, #66BB6A)";
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 6px 15px rgba(46,125,50,0.4)";
                          }}
                        >
                          <i className="fa-solid fa-circle-plus me-2"></i> Fabric Receive
                        </Button>

      {/* ================= TABLE ================= */}

      {loading && (
                <div className="loader-wrapper">
                    <div className="blue-spinner"></div>

                    <div className="loading-line">
                    <div className="loading-progress"></div>
                    </div>

                    <p className="loading-text">Loading, please wait...</p>
                </div>
            )}
    {!loading && (
        <Card className="mb-4 border-0"
        style={{
        background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
        boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
        }}>
    <Table bordered hover responsive striped>
        <thead>
        <tr>
            <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>SL</th>


            <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>Date</th>

            <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>Fabric Type</th>

            <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>In Quantity (In Mtr)</th>
            <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>Balance Quantity (In Mtr)</th>


{/* <th style={{
                padding: "5px",
                fontWeight: "600",
                letterSpacing: "0.5px",
                borderTopLeftRadius: "10px",
                backgroundColor: "#edf7fe",
                height: "10px",
                borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign: "center",
            }}>Action</th> */}




        </tr>
        </thead>
        <tbody>
{!loading && procurementList.length === 0 && (
<tr>
    <td colSpan="5" className="text-center text-muted">
    No records found
    </td>
</tr>
)}

{procurementList.map((row, index) => (
<tr key={row.id}>
     <td className="text-center">
          {(page - 1) * perPage + index + 1}
        </td>
    <td className="text-center">{formatDate(row.custom_date) || "-"}</td>

    {/* Vendor not available in API */}

    {/* Fabric Name */}
    <td className="text-center">{row.fabric_name}</td>
    <td className="text-center">{row.quantity_in}</td>

    {/* Quantity */}
    <td className="text-center">{row.current_quantity}</td>

    {/* <td className="text-center">
  <Button
  size="sm"
  variant="warning"
  onClick={() => handleEditClick(row)}
>
  Edit
</Button>

</td> */}



    {/* <td className="text-center">
    <Button size="sm" variant="warning" onClick={() => handleEditClick(row)}>
        Edit
    </Button>
    </td> */}
</tr>
))}
</tbody>

<Modal
  show={showProcureModal}
  onHide={() => setShowProcureModal(false)}
  size="lg"
  centered
   backdrop="static"
  keyboard={false}
>
  <Modal.Header closeButton style={{ background: "#3399ff", color: "#fff" }}>
    <Modal.Title>Fabric Receive</Modal.Title>
  </Modal.Header>

  <Modal.Body>

    {/* ROW 1 : DATE */}
    <Row className="mb-3 align-items-center">
      <Col md={6}>
        <Form.Group>
          <Form.Label>
            Date  <span className="text-danger">*</span>
          </Form.Label>
            <Form.Control
              type="date"
              value={fabricForm.date}
  onChange={(e) =>
    setFabricForm({ ...fabricForm, date: e.target.value })
  }
            />


        </Form.Group>
      </Col>
      <Col md={6}>
       <Form.Group>
          <Form.Label>Select Fabric Type <span className="text-danger">*</span></Form.Label>
         <Form.Select
   value={fabricForm.fabric_id}
  onChange={(e) => {
    const selectedFabricId = e.target.value;

    const selectedFabric = fabricList.find(
      (f) => f.id.toString() === selectedFabricId
    );

    setSelectedUnit(selectedFabric?.fabric_unit_short_name || "");

    setFabricForm((prev) => ({
      ...prev,
      fabric_id: selectedFabricId,
      requisition_qty: "",
    }));

    fetchFabricRequisitionQty(selectedFabricId);
  }} style={{ color: "#000", backgroundColor: "#fff" }}
>
  <option value="">Select Fabric</option>
  {fabricList.map((f) => (
    <option key={f.id} value={f.id}>
      {f.name}
    </option>
  ))}
</Form.Select>




        </Form.Group>
      </Col>
    </Row>

    {/* ROW 3 : REQUIRED QTY (DISABLED) + QTY TO PROCURE */}
    <Row className="mb-3">
      <Col md={6}>
        <Form.Group>
          <Form.Label>Requisition Quantity {selectedUnit && `(in ${selectedUnit})`}
  <span className="text-danger">*</span></Form.Label>
          <Form.Control
  type="number"
  value={fabricForm.requisition_qty}
  disabled
  placeholder={loadingReqQty ? "Loading..." : ""}
 />

        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label> Procurement Quantity {selectedUnit && `(in ${selectedUnit})`}  <span className="text-danger">*</span></Form.Label>
          <Form.Control
  type="number"
  placeholder="Enter quantity"
  value={fabricForm.quantity}
  onChange={(e) =>
    setFabricForm({ ...fabricForm, quantity: e.target.value })
  }
/>

        </Form.Group>
      </Col>
    </Row>

    {/* ROW 4 : CHALLAN DETAILS */}
    <div
      style={{
        marginTop: "20px",
        padding: "15px",
        background: "#F1F8FF",
        borderRadius: "10px",
        border: "1px solid #D6E6FA",
      }}
    >
      <Row>

        <Col md={6}>

        <Form.Group>
  <Form.Label disabled>Organisation <span className="text-danger">*</span></Form.Label>
  <Form.Control
  type="text"
  value={fabricForm.vendor}
  readOnly
  disabled
/>



</Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Reference Number  <span className="text-danger">*</span></Form.Label>
            <Form.Control
  type="text"
  placeholder="Enter Reference Number"
  value={fabricForm.challan_number}
  onChange={(e) =>
    setFabricForm({ ...fabricForm, challan_number: e.target.value })
  }
/>

          </Form.Group>
        </Col>

        <Col md={6} className="mt-3">
          <Form.Group>
            <Form.Label>Challan Date <span className="text-danger">*</span></Form.Label>
            <Form.Control
  type="date"
  value={fabricForm.challan_date}
  onChange={(e) =>
    setFabricForm({ ...fabricForm, challan_date: e.target.value })
  }
/>

          </Form.Group>
        </Col>


      </Row>
    </div>

  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowProcureModal(false)}>
      Cancel
    </Button>
    <Button
  variant="success"
  onClick={handleSaveFabricProcurement}
  disabled={saving}
>
  {saving ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
      ></span>
      Saving...
    </>
  ) : (
    "Save Procure"
  )}
</Button>
  </Modal.Footer>
</Modal>



    </Table>


    {/* PAGINATION */}
    {totalPages > 1 && (
      <div className="d-flex justify-content-center mt-4">
        <nav>
          <ul className="pagination shadow-sm">
            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricProcurement(1)}>«</button>
            </li>

            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricProcurement(page - 1)}>‹</button>
            </li>

            {getPageNumbers().map((p) => (
              <li key={p} className={`page-item ${page === p ? "active" : ""}`}>
                <button className="page-link" onClick={() => fetchFabricProcurement(p)}>
                  {p}
                </button>
              </li>
            ))}

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricProcurement(page + 1)}>›</button>
            </li>

            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => fetchFabricProcurement(totalPages)}>»</button>
            </li>
          </ul>
        </nav>
      </div>
    )}
    </Card>
    )}



    </div>
  );
};

export default FabricReceive;
